import {
    AssortmentApi,
    AssortmentGetAttributeProductsPOSTRequest,
    AssortmentGetCategoriesRequest,
    AssortmentGetProductRequest,
    AssortmentGetProductsPOSTRequest,
    FilterOutput,
    ShopAttributeProductPageInfo,
    ShopCompleteProduct,
    ShopFilterInput,
    ShopListProductPageInfo,
    SkuPriceInput,
} from 'microshop-api';
import { config } from './api';

const assortmentApi = new AssortmentApi(config);

const assortment = {
    getProduct: ({ category, product }: AssortmentGetProductRequest): Promise<ShopCompleteProduct> => {
        return assortmentApi.assortmentGetProduct({ category, product });
    },
    getListProducts: (
        {
            selectedFilters,
            orderBy = 'relevance',
            pageSize = 12,
            requestBody = [],
            page,
            search,
        }: AssortmentGetProductsPOSTRequest,
        cancelRequest?: AbortSignal,
    ): Promise<ShopListProductPageInfo> =>
        assortmentApi.assortmentGetProductsPOST(
            { selectedFilters, orderBy, pageSize, page, requestBody, search },
            { signal: cancelRequest },
        ),
    getAttributeProducts: (
        {
            selectedFilters,
            orderBy = 'relevance',
            pageSize = 12,
            requestBody = [],
            page,
            search,
        }: AssortmentGetAttributeProductsPOSTRequest,
        cancelRequest?: AbortSignal,
    ): Promise<ShopAttributeProductPageInfo> =>
        assortmentApi.assortmentGetAttributeProductsPOST(
            { selectedFilters, orderBy, pageSize, page, requestBody, search },
            { signal: cancelRequest },
        ),

    getFilters: (
        { assortmentIds, selectedFilters }: ShopFilterInput,
        cancelRequest?: AbortSignal,
    ): Promise<FilterOutput[]> =>
        assortmentApi.assortmentGetFiltersPOST(
            {
                shopFilterInput: {
                    assortmentIds,
                    selectedFilters,
                },
            },
            { signal: cancelRequest },
        ),
    getPrice: (price: [SkuPriceInput]) => assortmentApi.assortmentPricePOST({ skuPriceInput: price }),
    getCategories: ({ assortmentEntryPoint, includeProducts = false }: AssortmentGetCategoriesRequest) =>
        assortmentApi.assortmentGetCategories({ assortmentEntryPoint, includeProducts }),
};

export { assortment };
